export var MooringAfterArrivalContent;
(function (MooringAfterArrivalContent) {
    MooringAfterArrivalContent["GangwayReady"] = "gangway ready";
    MooringAfterArrivalContent["FreePractiqueGranted"] = "free practique granted";
    MooringAfterArrivalContent["FinishWithEngine"] = "finish with engine";
})(MooringAfterArrivalContent || (MooringAfterArrivalContent = {}));
//# sourceMappingURL=MooringAfterArrivalContent.js.map